import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

export const CARREGAR = 'carregar';
export const ATUALIZAR = 'atualizar';
export const SALVAR = 'salvar';
export const ENVIAR = 'enviar';

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {

  constructor() { }

  handleError(response, method) {
    console.log("response", response);
    console.log("response", response.error);
    console.log('Tipo:', response.error.constructor.name);
    let errorMessage = `Ocorreu um erro ao tentar ${method} os dados.\n\n`;
    if (response.error instanceof ErrorEvent) {
      errorMessage += `Client Side! \nError: ${response.error.message}`;
    }else if(response.error instanceof HttpErrorResponse){
      alert('handleApiError aaaaaaaaaaaaaaa');

    } else {
      errorMessage += `Server Side! \nError Code: ${response.status}\nMessage: ${response.message}`;
    }
    alert(errorMessage);
    return throwError(errorMessage);
  }

  handleApiError(response, method: string) {
    const responseError = response && response.error;
    const backendMessage = typeof responseError === 'string'
      ? responseError
      : responseError && (responseError.message || responseError.error || responseError.detail);
    const message = backendMessage || (response && response.message) ||
      `Ocorreu um erro ao tentar ${method} os dados.`;
    return throwError(message);
  }

  //TODO - avaliar envio para paginas de erro de acordo com o código da mensagem. Ex: Acesso negado, Login, Home
  handleServerSideError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 400:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 401:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 403:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 405:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 408:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 500:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 503:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      default:
        break;
    }
  }
}
